<input type="file" name="name" id="{{name}}" class="inputfile form-control-file display-hidden" (change)="onFileChange($event)"
  [accept]="accept" />
<label for="file" class="btn btn-raised {{ btnStyleClasses }} cursor-pointer" (click)="openFileBrowser($event)">
  <span class="ft-upload"></span> {{ buttonText }}</label>
<p class="info text-bold-300 display-inline-block ml-2">{{ fileName }}</p>